import boletaApi from "./boletaApi";

export const getEmployee = async (employeeId) => {
  const response = await boletaApi.get("/getEmployee", {
    params: { id: employeeId },
  });
  return response.data;
};
